export function formatNumber(num: number): string {
  if (!Number.isFinite(num)) {
    return String(num)
  }

  const isNegative = num < 0
  const absNum = Math.abs(num)
  let result: string

  if (absNum < 10000) {
    result = Number.isInteger(absNum) ? String(absNum) : parseFloat(absNum.toFixed(2)).toString()
  } else if (absNum < 99999999) {
    result = formatWithUnit(absNum / 10000, '万')
  } else {
    result = formatWithUnit(absNum / 100000000, '亿')
  }

  return isNegative ? `-${result}` : result
}

function formatWithUnit(value: number, unit: '万' | '亿'): string {
  const formatted = value.toFixed(1)

  if (formatted.endsWith('.0')) {
    return `${parseInt(formatted, 10)}${unit}`
  }

  return `${formatted}${unit}`
}
